import { useCluster, useRegionConfig } from "in_queue/contexts/ClusterContext";
import { useSubscriptions } from "in_queue/contexts/InQueueSubscriptionsContext";
import { isSameCluster } from "in_queue/types/clusterType";
import {
    CustomUpgradesStatus,
    customUpgradesStatus,
    CUSTOM_UPGRADES_ADD_ON
} from "in_queue/utils/customUpgradesStatus";

/**
 * Resolves the custom-upgrades status for the cluster currently in context.
 * Gathers the two gates — the region config and the cluster subscription's
 * add-on — and defers to {@link customUpgradesStatus}.
 */
export const useCustomUpgradesStatus = (): CustomUpgradesStatus => {
    const regionConfig = useRegionConfig();
    const cluster = useCluster();
    const subscriptions = useSubscriptions();

    // Until subscriptions resolve we can't know the add-on; stay hidden rather
    // than briefly flash the upsell on a cluster the team has unlocked.
    if (subscriptions === "loading") return "hidden";

    const hasAddOn = subscriptions.some(
        (subscription) =>
            isSameCluster(subscription.clusterInfo, cluster) &&
            subscription.addOns.includes(CUSTOM_UPGRADES_ADD_ON)
    );

    return customUpgradesStatus({
        regionEnabled: regionConfig.customUpgrades.enabled,
        hasAddOn
    });
};
